// extracted by mini-css-extract-plugin
export var button = "_f8-4";
export var hasDarkBackground = "_f8-7";
export var hasLightBackground = "_f8-6";
export var iconWrapper = "_f8-0";
export var large = "_f8-2";
export var medium = "_f8-1";
export var small = "_f8-5";
export var xsmall = "_f8-3";